// src/Pages/SendEmail.js
import React from "react";

export default function SendEmailPage() {
  return (
    <div>
      <h1>Send Email</h1>
      <p>Send emails to your users here.</p>
    </div>
  );
}
